import { Navigate } from "react-router";
import { useAuth } from "@/hooks/useAuth";
import type { JSX } from "react";

interface PrivateRouteProps {
  children: JSX.Element;
  requiredPermission?: string;
}

export const PrivateRoute = ({
  children,
  requiredPermission,
}: PrivateRouteProps) => {
  const { auth, hasPermission, ready } = useAuth();

  if (!ready) {
    return null; // o un spinner ligero mientras se rehidrata
  }

  if (ready && !auth) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
